import { CHART_COLORS, DEFAULT_TICKER } from "@/shared/constants/common";
import tailwindConfig from "~/tailwind.config.ts";
import { ChartTypes, Datasets, Subcharts, Timeframes } from "./types";

export const chartColors = {
	up: tailwindConfig.theme.extend.colors.epsm.up || "green",
	down: tailwindConfig.theme.extend.colors.epsm.down || "red",
	volumesUp: tailwindConfig.theme.extend.colors.volumes.up || "green",
	volumesDown: tailwindConfig.theme.extend.colors.volumes.down || "red",
	background: tailwindConfig.theme.extend.colors.background || "black",
	dot: "white",
	text: "white",
	border: "#71649C",
	consolidation: tailwindConfig.theme.extend.colors.consolidation || "yellow",
	orange: tailwindConfig.theme.extend.colors.orange || "orange",
	lightYellow: tailwindConfig.theme.extend.colors.lightYellow || "#ffffc5",
	lightGoldenYellow: "#f3bd3e",
	weakOrange: "#ff9600",
	gold: CHART_COLORS.GOLD,
	platinum: "#b3aa89",
	lightGreen: "#79f187",
};

export const getExpectedIndicatorValues = (constructorValue: any) => [
	{
		name: Subcharts.TimingMomentum,
		metainfo: {
			id: `${Subcharts.TimingMomentum}@tv-basicstudies-1`,
			description: Subcharts.TimingMomentum,
			shortDescription: Subcharts.TimingMomentum,
			isCustomIndicator: true,
			is_price_study: false,
			palettes: {
				paletteId1: {
					colors: {
						0: {
							name: "Down color",
						},
						1: {
							name: "Consolidation color",
						},
						2: {
							name: "Up color",
						},
						3: {
							name: "Missing",
						},
					},
				},
			},
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
				{
					id: "plot_2",
					type: "line",
				},
				{
					id: "plot_3",
					type: "line",
				},
				{
					id: "plot_4",
					type: "line",
				},
				{
					id: "plot_5",
					type: "line",
				},
				{
					id: "plot_10",
					type: "line",
				},
				{
					id: "plot_6",
					type: "colorer",
					target: "plot_2",
					palette: "paletteId1",
				},
				{
					id: "plot_7",
					type: "colorer",
					target: "plot_3",
					palette: "paletteId1",
				},
				{
					id: "plot_8",
					type: "colorer",
					target: "plot_4",
					palette: "paletteId1",
				},
				{
					id: "plot_9",
					type: "colorer",
					target: "plot_5",
					palette: "paletteId1",
				},
				{
					id: "plot_11",
					type: "colorer",
					target: "plot_10",
					palette: "paletteId1",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 4,
						linestyle: 0,
						linewidth: 5,
						visible: true,
						transparency: 0,
						color: "black",
					},
					plot_2: {
						plottype: 4,
						linewidth: 5,
						linestyle: 0,
						visible: true,
						transparency: 0,
					},
					plot_3: {
						plottype: 4,
						linewidth: 5,
						linestyle: 0,
						visible: true,
						transparency: 0,
					},
					plot_4: {
						plottype: 4,
						linestyle: 0,
						linewidth: 5,
						visible: true,
						transparency: 0,
					},
					plot_5: {
						plottype: 4,
						linewidth: 5,
						linestyle: 0,
						visible: true,
						transparency: 0,
					},
					plot_10: {
						plottype: 4,
						linewidth: 5,
						linestyle: 0,
						visible: true,
						transparency: 0,
					},
				},
				palettes: {
					paletteId1: {
						colors: {
							0: {
								color: chartColors.down,
								width: 1,
								style: 0,
							},
							1: {
								color: chartColors.consolidation,
								width: 1,
								style: 0,
							},
							2: {
								color: chartColors.up,
								width: 1,
								style: 0,
							},
							3: {
								color: "black",
								width: 1,
								style: 0,
							},
						},
					},
				},
			},
			styles: {
				plot_0: {
					title: "Visual space up",
					histogramBase: 0,
				},
				plot_2: {
					title: "Trend",
					histogramBase: 0,
				},
				plot_3: {
					title: Subcharts.PriceMomSlope,
					histogramBase: 0,
				},
				plot_4: {
					title: "RMR 10Day Slope",
					histogramBase: 0,
				},
				plot_5: {
					title: Subcharts.PwdTrend,
					histogramBase: 0,
				},
				plot_10: {
					title: "EMA 20/50",
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Subcharts.Powerdays,
		metainfo: {
			id: `${Subcharts.Powerdays}@tv-basicstudies-1`,
			description: Subcharts.Powerdays,
			shortDescription: Subcharts.Powerdays,
			is_price_study: false,
			palettes: {
				paletteId1: {
					colors: {
						0: {
							name: "Down color",
						},
						1: {
							name: "Consolidation color",
						},
						2: {
							name: "Up color",
						},
					},
				},
			},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
				{
					id: "plot_1",
					type: "colorer",
					target: "plot_0",
					palette: "paletteId1",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 1,
						linestyle: 0,
						visible: true,
						transparency: 0,
					},
				},
				palettes: {
					paletteId1: {
						colors: {
							0: {
								color: chartColors.down,
								width: 5,
								style: 0,
							},
							1: {
								color: chartColors.consolidation,
								width: 5,
								style: 0,
							},
							2: {
								color: chartColors.up,
								width: 5,
								style: 0,
							},
						},
					},
				},
			},
			styles: {
				plot_0: {
					title: Subcharts.Powerdays,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Subcharts.PwdTrend,
		metainfo: {
			id: `${Subcharts.PwdTrend}@tv-basicstudies-1`,
			description: Subcharts.PwdTrend,
			shortDescription: Subcharts.PwdTrend,
			is_price_study: false,
			palettes: {
				paletteId1: {
					colors: {
						0: {
							name: "Down color",
						},
						1: {
							name: "Consolidation color",
						},
						2: {
							name: "Up color",
						},
					},
				},
			},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
				{
					id: "plot_1",
					type: "line",
				},
				{
					id: "plot_2",
					type: "colorer",
					target: "plot_1",
					palette: "paletteId1",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 4,
						linestyle: 0,
						linewidth: 5,
						visible: true,
						transparency: 0,
						color: "black",
					},
					plot_1: {
						plottype: 4,
						linewidth: 5,
						linestyle: 0,
						visible: true,
						transparency: 0,
					},
				},
				palettes: {
					paletteId1: {
						colors: {
							0: {
								color: chartColors.down,
								width: 1,
								style: 0,
							},
							1: {
								color: chartColors.consolidation,
								width: 1,
								style: 0,
							},
							2: {
								color: chartColors.up,
								width: 1,
								style: 0,
							},
						},
					},
				},
			},
			styles: {
				plot_0: {
					title: "Visual space",
					histogramBase: 0,
				},
				plot_1: {
					title: Subcharts.PwdTrend,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Subcharts.RMRComp,
		metainfo: {
			id: `${Subcharts.RMRComp}@tv-basicstudies-1`,
			description: Subcharts.RMRComp,
			shortDescription: Subcharts.RMRComp,
			is_price_study: false,
			palettes: {},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.lightYellow,
					},
				},
			},
			styles: {
				plot_0: {
					title: Subcharts.RMRComp,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Subcharts.RMRMonthly,
		metainfo: {
			id: `${Subcharts.RMRMonthly}@tv-basicstudies-1`,
			description: Subcharts.RMRMonthly,
			shortDescription: Subcharts.RMRMonthly,
			palettes: {},
			is_price_study: false,
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
				{
					id: "plot_1",
					type: "line",
				},
				{
					id: "plot_2",
					type: "line",
				},
				{
					id: "plot_3",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.lightYellow,
					},
					plot_1: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.consolidation,
					},
					plot_2: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.orange,
					},
					plot_3: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.down,
					},
				},
			},
			styles: {
				plot_0: {
					title: "1 Month",
					histogramBase: 0,
				},
				plot_1: {
					title: "3 Months",
					histogramBase: 0,
				},
				plot_2: {
					title: "6 Months",
					histogramBase: 0,
				},
				plot_3: {
					title: "1 Year",
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Subcharts.RMRSlope,
		metainfo: {
			id: `${Subcharts.RMRSlope}@tv-basicstudies-1`,
			description: Subcharts.RMRSlope,
			shortDescription: Subcharts.RMRSlope,
			is_price_study: false,
			palettes: {
				paletteId1: {
					colors: {
						0: {
							name: "Down color",
						},
						1: {
							name: "Consolidation color",
						},
						2: {
							name: "Up color",
						},
					},
				},
			},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
				{
					id: "plot_1",
					type: "colorer",
					target: "plot_0",
					palette: "paletteId1",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 5,
						linestyle: 0,
						visible: true,
						transparency: 0,
					},
				},
				palettes: {
					paletteId1: {
						colors: {
							0: {
								color: chartColors.orange,
								width: 1,
								style: 0,
							},
							1: {
								color: chartColors.lightYellow,
								width: 1,
								style: 0,
							},
							2: {
								color: chartColors.lightYellow,
								width: 1,
								style: 0,
							},
						},
					},
				},
			},
			styles: {
				plot_0: {
					title: Subcharts.RMRSlope,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Subcharts.PriceMomSlope,
		metainfo: {
			id: `${Subcharts.PriceMomSlope}@tv-basicstudies-1`,
			description: Subcharts.PriceMomSlope,
			shortDescription: Subcharts.PriceMomSlope,
			is_price_study: false,
			palettes: {
				paletteId1: {
					colors: {
						0: {
							name: "Down color",
						},
						1: {
							name: "Consolidation color",
						},
						2: {
							name: "Up color",
						},
					},
				},
			},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
				{
					id: "plot_1",
					type: "colorer",
					target: "plot_0",
					palette: "paletteId1",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 5,
						linestyle: 0,
						visible: true,
						transparency: 0,
					},
				},
				palettes: {
					paletteId1: {
						colors: {
							0: {
								color: chartColors.down,
								width: 5,
								style: 0,
							},
							1: {
								color: chartColors.consolidation,
								width: 5,
								style: 0,
							},
							2: {
								color: chartColors.up,
								width: 5,
								style: 0,
							},
						},
					},
				},
			},
			styles: {
				plot_0: {
					title: Subcharts.PriceMomSlope,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Subcharts.InxRatTrendSlope,
		metainfo: {
			id: `${Subcharts.InxRatTrendSlope}@tv-basicstudies-1`,
			description: Subcharts.InxRatTrendSlope,
			shortDescription: Subcharts.InxRatTrendSlope,
			is_price_study: false,
			palettes: {
				paletteId1: {
					colors: {
						0: {
							name: "Down color",
						},
						1: {
							name: "Consolidation color",
						},
						2: {
							name: "Up color",
						},
					},
				},
			},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
				{
					id: "plot_1",
					type: "colorer",
					target: "plot_0",
					palette: "paletteId1",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linewidth: 3,
						linestyle: 0,
						visible: true,
						transparency: 0,
					},
				},
				palettes: {
					paletteId1: {
						colors: {
							0: {
								color: chartColors.down,
								width: 3,
								style: 0,
							},
							1: {
								color: chartColors.consolidation,
								width: 3,
								style: 0,
							},
							2: {
								color: chartColors.up,
								width: 3,
								style: 0,
							},
						},
					},
				},
			},
			styles: {
				plot_0: {
					title: Subcharts.InxRatTrendSlope,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Subcharts.SectInxRatTrend,
		metainfo: {
			id: `${Subcharts.SectInxRatTrend}@tv-basicstudies-1`,
			description: Subcharts.SectInxRatTrend,
			shortDescription: Subcharts.SectInxRatTrend,
			isCustomIndicator: true,
			palettes: {},
			is_price_study: false,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
				{
					id: "plot_1",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: "#FF0000",
					},
					plot_1: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
					},
				},
			},
			styles: {
				plot_0: {
					title: "Sector Ratio Trend",
					histogramBase: 0,
				},
				plot_1: {
					title: "Index Ratio Trend",
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Subcharts.VolStrength,
		metainfo: {
			id: `${Subcharts.VolStrength}@tv-basicstudies-1`,
			description: Subcharts.VolStrength,
			shortDescription: Subcharts.VolStrength,
			is_price_study: false,
			palettes: {
				paletteId1: {
					colors: {
						0: {
							name: "Down color",
						},
						1: {
							name: "Up color",
						},
					},
				},
			},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
				{
					id: "plot_1",
					type: "line",
				},
				{
					id: "plot_2",
					type: "line",
				},
				{
					id: "plot_3",
					type: "colorer",
					target: "plot_0",
					palette: "paletteId1",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 5,
						linestyle: 0,
						visible: true,
						transparency: 0,
					},
					plot_1: {
						plottype: 0,
						linestyle: 1,
						linewidth: 1,
						visible: true,
						transparency: 0,
						color: CHART_COLORS.GOLD,
					},
					plot_2: {
						plottype: 0,
						linestyle: 1,
						linewidth: 1,
						visible: true,
						transparency: 0,
						color: CHART_COLORS.GOLD,
					},
				},
				palettes: {
					paletteId1: {
						colors: {
							0: {
								color: chartColors.orange,
								width: 5,
								style: 0,
							},
							1: {
								color: chartColors.consolidation,
								width: 5,
								style: 0,
							},
						},
					},
				},
			},
			styles: {
				plot_0: {
					title: Subcharts.VolStrength,
					histogramBase: 0,
				},
				plot_1: {
					title: "Positive line",
					histogramBase: 0,
				},
				plot_2: {
					title: "Negative line",
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.PETTM,
		metainfo: {
			id: `${Datasets.PETTM}@tv-basicstudies-1`,
			description: Datasets.PETTM,
			shortDescription: Datasets.PETTM,
			is_price_study: false,
			palettes: {},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 25,
						color: chartColors.orange,
					},
				},
			},
			styles: {
				plot_0: {
					title: Datasets.PETTM,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.PEFTM,
		metainfo: {
			id: `${Datasets.PEFTM}@tv-basicstudies-1`,
			description: Datasets.PEFTM,
			shortDescription: Datasets.PEFTM,
			is_price_study: false,
			palettes: {},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.orange,
					},
				},
			},
			styles: {
				plot_0: {
					title: Datasets.PEFTM,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.EPS,
		metainfo: {
			id: `${Datasets.EPS}@tv-basicstudies-1`,
			description: Datasets.EPS,
			shortDescription: Datasets.EPS,
			is_price_study: false,
			palettes: {},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.up,
					},
				},
			},
			styles: {
				plot_0: {
					title: Datasets.EPS,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.Sales,
		metainfo: {
			id: `${Datasets.Sales}@tv-basicstudies-1`,
			description: Datasets.Sales,
			shortDescription: Datasets.Sales,
			is_price_study: false,
			palettes: {},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.platinum,
					},
				},
			},
			styles: {
				plot_0: {
					title: `${Datasets.Sales} (in Millions)`,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.ProfMargin,
		metainfo: {
			id: `${Datasets.ProfMargin}@tv-basicstudies-1`,
			description: Datasets.ProfMargin,
			shortDescription: Datasets.ProfMargin,
			is_price_study: false,
			palettes: {},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.gold,
					},
				},
			},
			styles: {
				plot_0: {
					title: Datasets.ProfMargin,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.FreeCFlow,
		metainfo: {
			id: `${Datasets.FreeCFlow}@tv-basicstudies-1`,
			description: Datasets.FreeCFlow,
			shortDescription: Datasets.FreeCFlow,
			is_price_study: false,
			palettes: {},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.lightYellow,
					},
				},
			},
			styles: {
				plot_0: {
					title: `${Datasets.FreeCFlow} (in Millions)`,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.EVEb,
		metainfo: {
			id: `${Datasets.EVEb}@tv-basicstudies-1`,
			description: Datasets.EVEb,
			shortDescription: Datasets.EVEb,
			is_price_study: false,
			palettes: {},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 15,
						color: chartColors.gold,
					},
				},
			},
			styles: {
				plot_0: {
					title: Datasets.EVEb,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.RSEZ,
		metainfo: {
			id: `${Datasets.RSEZ}@tv-basicstudies-1`,
			description: Datasets.RSEZ,
			shortDescription: Datasets.RSEZ,
			is_price_study: false,
			palettes: {},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.up,
					},
				},
			},
			styles: {
				plot_0: {
					title: Datasets.RSEZ,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.RSSZ,
		metainfo: {
			id: `${Datasets.RSSZ}@tv-basicstudies-1`,
			description: Datasets.RSSZ,
			shortDescription: Datasets.RSSZ,
			is_price_study: false,
			palettes: {},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.gold,
					},
				},
			},
			styles: {
				plot_0: {
					title: Datasets.RSSZ,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.RSEF,
		metainfo: {
			id: `${Datasets.RSEF}@tv-basicstudies-1`,
			description: Datasets.RSEF,
			shortDescription: Datasets.RSEF,
			is_price_study: false,
			palettes: {},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 25,
						color: chartColors.up,
					},
				},
			},
			styles: {
				plot_0: {
					title: Datasets.RSEF,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.RSSF,
		metainfo: {
			id: `${Datasets.RSSF}@tv-basicstudies-1`,
			description: Datasets.RSSF,
			shortDescription: Datasets.RSSF,
			is_price_study: false,
			palettes: {},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.consolidation,
					},
				},
			},
			styles: {
				plot_0: {
					title: Datasets.RSSF,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.ShortInt,
		metainfo: {
			id: `${Datasets.ShortInt}@tv-basicstudies-1`,
			description: Datasets.ShortInt,
			shortDescription: Datasets.ShortInt,
			is_price_study: false,
			palettes: {},
			isCustomIndicator: true,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.down,
					},
				},
			},
			styles: {
				plot_0: {
					title: Datasets.ShortInt,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.DarkShort,
		metainfo: {
			id: `${Datasets.DarkShort}@tv-basicstudies-1`,
			description: Datasets.DarkShort,
			shortDescription: Datasets.DarkShort,
			isCustomIndicator: true,
			palettes: {},
			is_price_study: false,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 0,
						color: chartColors.lightGreen,
					},
				},
			},
			styles: {
				plot_0: {
					title: Datasets.DarkShort,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
	{
		name: Datasets.DarkShortSlope,
		metainfo: {
			id: `${Datasets.DarkShortSlope}@tv-basicstudies-1`,
			description: Datasets.DarkShortSlope,
			shortDescription: Datasets.DarkShortSlope,
			isCustomIndicator: true,
			palettes: {},
			is_price_study: false,
			format: { precision: 2, type: "price" },
			plots: [
				{
					id: "plot_0",
					type: "line",
				},
			],
			defaults: {
				styles: {
					plot_0: {
						plottype: 0,
						linestyle: 0,
						visible: true,
						transparency: 20,
						color: chartColors.up,
					},
				},
			},
			styles: {
				plot_0: {
					title: Datasets.DarkShortSlope,
					histogramBase: 0,
				},
			},
			inputs: [],
		},
		constructor: constructorValue,
	},
];

export const initialChartState = {
	ticker: DEFAULT_TICKER,
	timeFrame: Timeframes.ONE_DAY,
	type: ChartTypes.ADVANCED,
	panels: ["Timing Momentum"],
};
